import { z } from 'zod';
import { request } from './apiClient';
import {
  GuestRegistrationResponse, RoomDto, RoomSettingsDto,
  RoundDto, WordResultDto, ProgressDto, RoundResultsDto, MatchDto,
  PlayerProfileDto,
} from './dto';

const TelegramAuthResponse = z.object({
  playerId: z.string(),
  nickname: z.string(),
  telegramUserId: z.number(),
});
type TelegramAuthResponseType = z.infer<typeof TelegramAuthResponse>;

export const api = {
  auth: {
    telegramMiniApp: (initData: string) =>
      request<TelegramAuthResponseType>('/auth/telegram-mini-app', {
        method: 'POST',
        body: { initData },
        schema: TelegramAuthResponse,
      }),
  },
  players: {
    registerGuest: (nickname: string) =>
      request<GuestRegistrationResponse>('/players/guest', {
        method: 'POST',
        body: { nickname },
        schema: GuestRegistrationResponse,
      }),
    profile: () =>
      request<PlayerProfileDto>('/players/me/profile', { schema: PlayerProfileDto }),
  },
  rooms: {
    getDefaults: () =>
      request<RoomSettingsDto>('/rooms/defaults', { schema: RoomSettingsDto }),
    create: (settings: Partial<RoomSettingsDto>) =>
      request<RoomDto>('/rooms', { method: 'POST', body: { settings }, schema: RoomDto }),
    get: (code: string) =>
      request<RoomDto>(`/rooms/${code}`, { schema: RoomDto }),
    join: (code: string) =>
      request<RoomDto>(`/rooms/${code}/join`, { method: 'POST', schema: RoomDto }),
    leave: (code: string) =>
      request<void>(`/rooms/${code}/leave`, { method: 'POST' }),
    setReady: (code: string, isReady: boolean) =>
      request<RoomDto>(`/rooms/${code}/ready`, {
        method: 'POST',
        body: { isReady },
        schema: RoomDto,
      }),
  },
  round: {
    get: (code: string) =>
      request<RoundDto>(`/rooms/${code}/round`, { schema: RoundDto }),
    submitWord: (code: string, word: string) =>
      request<WordResultDto>(`/rooms/${code}/round/words`, {
        method: 'POST',
        body: { word },
        schema: WordResultDto,
      }),
    getProgress: (code: string) =>
      request<ProgressDto>(`/rooms/${code}/round/progress`, { schema: ProgressDto }),
    getResults: (code: string) =>
      request<RoundResultsDto>(`/rooms/${code}/round/results`, { schema: RoundResultsDto }),
  },
  match: {
    get: (code: string) =>
      request<MatchDto>(`/rooms/${code}/match`, { schema: MatchDto }),
    restart: (code: string) =>
      request<void>(`/rooms/${code}/match/restart`, { method: 'POST' }),
  },
};
